// SprungNumber — a number that eases toward its target with the same critically-
// damped spring the scroll engine uses (halflife ~60ms: snappy, no overshoot).
// For VISITOR-OPERATED values (the calculator): the input moved, the number
// follows. Not for marketing figures — Readout's countUp owns those, with its
// own truth rules. Motion-disabled and no-JS contexts always get the target
// value instantly: the spring is the flourish, the value is the truth.
import { damp } from './springs';
import { motionDisabled } from './reduced';

export class SprungNumber {
	#current = $state(0);
	#target = 0;
	#raf = 0;

	constructor(initial: number) {
		this.#current = initial;
		this.#target = initial;
	}

	get current(): number {
		return this.#current;
	}

	set(target: number): void {
		this.#target = target;
		// Hidden tab: rAF is frozen there, so a spring started now would stick on a
		// mid-flight (wrong) value. Snap instead — the flourish is what gets dropped.
		if (motionDisabled() || document.hidden || typeof requestAnimationFrame === 'undefined') {
			this.#current = target;
			return;
		}
		if (this.#raf) return; // a loop is already chasing; retarget is enough
		let last = performance.now();
		const tick = (now: number) => {
			const dt = Math.min(now - last, 64);
			last = now;
			const next = damp(this.#current, this.#target, 60, dt);
			// Land exactly — sub-unit oscillation would keep the loop alive.
			this.#current = Math.abs(next - this.#target) < 0.5 ? this.#target : next;
			if (this.#current !== this.#target) {
				this.#raf = requestAnimationFrame(tick);
			} else {
				this.#raf = 0;
			}
		};
		this.#raf = requestAnimationFrame(tick);
	}
}
